import { z } from 'zod';
import { makeEvent } from './EventBase';
import { AssociationRequest } from '@/api';

export const AssociationRequestUpdated = makeEvent(
    'AssociationRequestUpdated',
    z.object({
        data: AssociationRequest,
    }),
);

export type AssociationRequestUpdated = (typeof AssociationRequestUpdated)['schema']['_output'];
